import React from 'react';
import PropTypes from 'prop-types';
import groupBy from 'lodash/groupBy';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

// import { stripHTML } from 'shared/helpers/strings';
// // import LeasingAndVin from 'shared/components/LeasingAndVin';
// import statusColors from 'shared/constants/json/statusColors.json';
// import CheckedVinBlock from 'shared/components/CheckedVinBlock/CheckedVinBlock';
// import AdvertStatusList from 'shared/components/AdvertStatusList/AdvertStatusList';

import s from './AdvertOptions.css';

class AdvertOptions extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        parents: PropTypes.arrayOf(PropTypes.shape()),
        id: PropTypes.number,
      }),
    ),
    intl: PropTypes.shape().isRequired,
  };

  static defaultProps = {
    options: [],
  };

  render() {
    const { options, title, intl } = this.props;

    const transformedOptions = options.map(option => {
      const { parents } = option;
      if (parents.length === 2) {
        const { title: optionTitle, parents: [mainParent, optionParent], ...rest } = option;
        return {
          ...rest,
          title: `${optionTitle} ${optionParent && optionParent.title
            ? optionParent.title.toLowerCase()
            : ''}`,
          parents: [mainParent],
        };
      }

      return option;
    });

    const groupedOption = Object.entries(groupBy(transformedOptions, 'parents[0].title')).sort(
      (a, b) => (a[1].length < b[1].length ? 1 : -1),
    );
    const groupCount = groupedOption.length;
    const titleH2 = `${intl.formatMessage({ id: 'Комплектация' })} ${intl.formatMessage({ id: 'авто' })} ${title}`;
    return (
      <div className={s.root}>
        {groupCount > 0 &&
          <div>
            <h2 className={s.title}>
              {titleH2}
            </h2>
            <div className={s.list}>
              {groupCount > 1 &&
                <div className={s.col}>
                  <PackageColumn column={groupedOption.slice(0, Math.floor(groupCount / 2))} />
                </div>}
              <div className={s.col}>
                <PackageColumn column={groupedOption.slice(Math.floor(groupCount / 2))} />
              </div>
            </div>
          </div>}
      </div>
    );
  }
}

function PackageColumn({ column }) {
  return (
    <ul className={s.group}>
      {column.filter(([group, options]) => group && options).map(([group, options]) =>
        <li className={s.optionGroup} key={group}>
          <div className={s.optionGroupTitle}>
            <FormattedMessage id={group} />
          </div>
          <ul className={s.optionList}>
            {options.map(({ title, id }) =>
              <li key={id} className={s.option}>
                <FormattedMessage id={title} />
              </li>,
            )}
          </ul>
        </li>,
      )}
    </ul>
  );
}
PackageColumn.propTypes = PropTypes.arrayOf(
  PropTypes.shape({
    group: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }),
).isRequired;

export default withStyles(s)(injectIntl(AdvertOptions));



// WEBPACK FOOTER //
// ./src/desktop/components/AdvertOptions/AdvertOptions.js